import { Alert, CollapseProps, Typography } from 'antd'

const { Title } = Typography

export const helpItems: CollapseProps['items'] = [
    {
        key: '1',
        label: <b>Обзор раздела и вкладки</b>,
        children: (
            <>
                <p>
                    Раздел «Приход флексоформ» — список заказов форм у поставщика, которые ожидаются
                    или уже приняты. Заказ создаёт дизайнер, когда выполняет задачу «Заказ форм» или
                    «Перезаказ форм». Заказ появляется здесь в статусе «Создан» и связан с
                    отгрузкой, под которую заказаны формы.
                </p>
                <Title level={3}>Вкладки</Title>
                <ul>
                    <li>
                        <b>Ожидаемые</b> — все заказы, которые ещё не приняты. Здесь отмечают
                        пришедшие формы, фиксируют брак и принимают заказ.
                    </li>
                    <li>
                        <b>Завершенные</b> — принятые заказы, только для просмотра.
                    </li>
                </ul>
                <p>На обеих вкладках сверху идут заказы с ближайшей датой поставки.</p>
            </>
        ),
    },
    {
        key: '2',
        label: <b>Колонки таблицы</b>,
        children: (
            <>
                <p>
                    Одна строка — одна форма. Общие поля заказа объединены на все его формы.
                </p>
                <ul>
                    <li>
                        <b>Номер</b> — номер заказа форм.
                    </li>
                    <li>
                        <b>Формы</b> — сколько форм в заказе.
                    </li>
                    <li>
                        <b>Статус</b> — текущий статус заказа.
                    </li>
                    <li>
                        <b>Дата создания</b> — когда заказ создан.
                    </li>
                    <li>
                        <b>Дата поставки</b> — ожидаемая дата поступления форм.
                    </li>
                    <li>
                        <b>Состав заказа</b>: <b>Комплект</b> (номер набора форм), <b>Номер</b>{' '}
                        формы, <b>Цвет</b> и его <b>Название</b>, отметка <b>В наличии</b> и{' '}
                        <b>Брак</b>.
                    </li>
                    <li>
                        <b>Действия</b> — приёмка заказа (только на вкладке «Ожидаемые»).
                    </li>
                </ul>
            </>
        ),
    },
    {
        key: '3',
        label: <b>Статусы заказа</b>,
        children: (
            <ul>
                <li>
                    <b>Создан</b> — заказ оформлен, формы ожидаются.
                </li>
                <li>
                    <b>В сборке</b> — поставщик изготавливает формы.
                </li>
                <li>
                    <b>В пути</b> — формы отправлены.
                </li>
                <li>
                    <b>Готов к выдаче</b> — формы готовы к получению.
                </li>
                <li>
                    <b>Завершен</b> — заказ принят.
                </li>
            </ul>
        ),
    },
    {
        key: '4',
        label: <b>Отметка «В наличии»</b>,
        children: (
            <>
                <p>
                    Когда форма пришла, поставьте галочку в колонке «В наличии». Отметка сохраняется
                    сразу. Формы можно отмечать по мере прихода, в несколько заходов: например, одну
                    утром, другую вечером.
                </p>
                <p>
                    До приёмки заказа отметку можно снять. У формы с зафиксированным браком отметка
                    недоступна.
                </p>
            </>
        ),
    },
    {
        key: '5',
        label: <b>Брак прихода</b>,
        children: (
            <>
                <p>
                    Если форма пришла с браком, нажмите <b>«Зафиксировать брак»</b> и подтвердите
                    действие. После этого:
                </p>
                <ul>
                    <li>у формы записывается причина «Брак прихода» и дата;</li>
                    <li>отметка «В наличии» снимается и становится недоступной;</li>
                    <li>
                        дизайнеру отгрузки создаётся задача «Перезаказ форм» на эту форму. Новая
                        форма придёт отдельным заказом;
                    </li>
                    <li>форма с браком не мешает принять текущий заказ.</li>
                </ul>
                <Alert
                    showIcon
                    message='Отменить зафиксированный брак в этом разделе нельзя.'
                    type='warning'
                />
            </>
        ),
    },
    {
        key: '6',
        label: <b>Приёмка заказа</b>,
        children: (
            <>
                <p>
                    Кнопка с галочкой <b>«Принять заказ»</b> в колонке «Действия» завершает заказ.
                    Подтверждения нет: приёмка выполняется сразу после нажатия.
                </p>
                <Title level={3}>Когда кнопка активна</Title>
                <ul>
                    <li>каждая форма заказа отмечена «В наличии» или с зафиксированным браком;</li>
                    <li>заказ не в статусе «В сборке».</li>
                </ul>
                <Title level={3}>После приёмки</Title>
                <p>
                    Заказ получает статус «Завершен» и переходит на вкладку «Завершенные». Там
                    отметки «В наличии» недоступны, а брак показан текстом: причина и дата.
                </p>
                <Alert
                    showIcon
                    message='Отметки, брак и приёмка доступны только на вкладке «Ожидаемые».'
                    type='info'
                />
            </>
        ),
    },
]
